import React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import { useNavigate } from 'react-router-dom';

const GuestRegisterDialog = ({ open, onClose }) => {
  const navigate = useNavigate();

  const handleContinue = () => {
    onClose();
    navigate('/buyersignup');
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth={true} maxWidth={'sm'}>
      <DialogTitle>Registration Required</DialogTitle>
      <DialogContent>
        <p>Only registered buyers with valid DL can register as buyer and place orders. Please initiate registration.</p>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color='secondary'>Cancel</Button>
        <Button onClick={handleContinue} color='primary'>Continue</Button>
      </DialogActions>
    </Dialog>
  );
};

export default GuestRegisterDialog;
